import { create } from "zustand";

const useOrderStore = create((set) => ({
  orders: [],
  setOrders: (orders) => {
    return set({ orders });
  },
}));

export default useOrderStore;
